import type { PropsWithChildren } from 'react'

import { cn } from '~/utils/classnames'

type ErrorPageProps = {
  title: string
  description: string
  className?: string
}

export function ErrorPage({
  title,
  description,
  children,
  className,
}: PropsWithChildren<ErrorPageProps>) {
  return (
    <div
      data-theme="protocol-light"
      className={cn(
        'bg-background/80 flex min-h-screen flex-col justify-between',
        className
      )}
    >
      <div className="hide-scrollbar bg-background/80 relative flex flex-1 flex-col items-center overflow-y-scroll px-2 py-8 @sm:p-6 @sm:pb-0">
        <div className="flex max-w-[340px] flex-1 flex-col items-center justify-center gap-2">
          <div className="my-5">
            <h4 className="text-foreground text-center text-xl font-medium">
              {title}
            </h4>
            <p className="text-foreground/64 mt-1 text-center text-sm">
              {description}
            </p>
          </div>

          {/* display for respective error types */}
          {children}
        </div>
      </div>
    </div>
  )
}
